import e from "@dialpad/dialtone-tokens/layered/themes/tokens-prota-deuter-colors.css?inline";
//#region themes/prota-deuter.js
var t = { brand: {
	css: e,
	name: "prota-deuter"
} };
//#endregion
export { t as default };
